export const language = {
  birthDate: 'تاریخ تولد',
  birthDateHint: 'تاریخ تولد شما باید بر اساس اطلاعات شناسنامه شما باشد.',
  minAgeHint: 'جهت سرمایه‌گذاری در طرح طلا 24 عیار، سن شما باید بالای 18 سال باشد.',
  title: 'تکمیل مشخصات',
  submit: 'ثبت و ادامه',
  submitPending: 'در حال استعلام از ثبت احوال',
  slowResponseWarning:
    'هنوز در حال دریافت پاسخ از ثبت احوال هستیم. لطفاً چند لحظه دیگر منتظر بمانید.',
  agreementsTitle: 'شروط و بیانیه ریسک',
  flowSubmit: 'شرایط را می‌پذیرم',
  ok: 'متوجه شدم',
  collapseTitle: 'شرایط عمومی بیمه نامه',
  buyTitle: 'درخواست خرید',
  sellTitle: 'درخواست فروش',
  buyTimeLimit: (openTime: string, closeTime: string) =>
    `با توجه به محدودیت موقت اعلام شده، ثبت درخواست خرید فقط از ساعت ${openTime} تا ${closeTime} امکان پذیر است.`,
  sellTimeLimit: (openTime: string, closeTime: string) =>
    `با توجه به محدودیت موقت اعلام شده، ثبت درخواست فروش فقط از ساعت ${openTime} تا ${closeTime} امکان پذیر است.`,
};
